export default __webpack_public_path__ + "static/media/NewMoreNavsIcon.f7d4f91b.svg";